module.exports = __webpack_public_path__ + "img/logo.e4e3db8f.svg";